import { useNavigate } from 'react-router'
import { 
  AppBar, 
  IconButton, 
  Toolbar 
} from "@mui/material";
import { 
  Menu as MenuIcon, 
  Search as SearchIcon,
  SpaceDashboardOutlined as SpaceDashboardOutlinedIcon,
  EditLocationAltOutlined as EditLocationAltOutlinedIcon,
  Person as PersonIcon
} from "@mui/icons-material";
import { styled } from "@mui/material";
import { useDispatch } from "react-redux";
import { openActiveBuildingSelect } from "@/features/building/buildingSlice";
import {
  openSidebarWithSearch,
  setIsSidebarOpen,
} from "@/features/layout/layoutSlice";
import useLayout from "@/features/layout/useLayout";

const Offset = styled('div')(({ theme }) => ({
  minHeight: Number(theme.mixins.toolbar.minHeight)
}));

const MobileBottomAppBar = () => {
  const { isMobile } = useLayout();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (!isMobile) return null;

  const handleNavigate = (path) => {
    dispatch(setIsSidebarOpen(false));
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <AppBar 
        position="fixed" 
        color="primary" 
        sx={{ 
          top: 'auto', 
          bottom: 0,
          zIndex: (theme) => theme.zIndex.drawer + 2,
        }}>
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: "space-between",
            gap: {
              xs: 1,
              sm: 2,
              md: 3,
            }
          }}
        >
          <IconButton
            onClick={() => dispatch(setIsSidebarOpen(true))} 
            color="inherit"
            aria-label="menu"
          >
            <MenuIcon />
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="search"
            onClick={() => dispatch(openSidebarWithSearch())}
          >
            <SearchIcon />
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="home"
            onClick={() => handleNavigate('/')}
          >
            <SpaceDashboardOutlinedIcon />
          </IconButton>
          <IconButton 
            onClick={() => dispatch(openActiveBuildingSelect())}
            color="inherit"
            aria-label="building"
          >
            <EditLocationAltOutlinedIcon />
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="profile"
            onClick={() => handleNavigate('/profile')}
          >
            <PersonIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Offset/>
    </>
  );
}

export default MobileBottomAppBar;
